// External
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  removeInfoFeedMessage,
  setDashboardParams,
  setInfoFeedMessage,
  setSessionVar,
} from "../../store/actions";
import { cloneDeep, debounce, filter, get } from "lodash";
import Moment from "moment";

//Maps Stuff
//I take control of the OL Map in a few functions here to simplify the process.
import Feature from "ol/Feature";
import VectorSource from "ol/source/Vector";
import { Polygon } from "ol/geom";
import { convexHull } from "../../utils/geom";
import convex from "@turf/convex";
import transformScale from "@turf/transform-scale";

// Internal
import BaseMap, {
  getFeaturesWithinScreen,
  isValidLngLat,
  setBoundsToSources,
} from "../maps/BaseMap";
import FloatHeader from "../theme/headers/FloatHeader";
import { defaultMapState } from "./CreateSite";
import InfoTileFeed from "../subscreens/InfoFeed";
import FilterDisplay from "../subscreens/FilterDisplay";
import {
  filterAndSortItems,
  handleFilterDeletion,
  handleSearchChange,
} from "../../utils/FilterDisplayUtils";
import TurfNoteModal from "../theme/modals/TurfNoteModal";
import TurfFilterModal from "../theme/modals/TurfFilterModal";
import DistrictNoteModal from "../theme/modals/DistrictNoteModal";
import DistrictFilterModal from "../theme/modals/DistrictFilterModal";

import Input from "../theme/forms/Input";
import Tabs from "../theme/menus/Tabs";
import BasicButton from "../theme/buttons/BasicButton";
import FeedbackTile from "../theme/modals/FeedbackTile";
import { coloredPolygonStyle } from "../maps/olStyles";
import DistrictTurfListItem from "../maps/listItems/DistrictTurfListItem";
import api from "../../store/api/api";
import BaseModal from "../theme/modals/BaseModal";
import BaseForm from "../theme/forms/BaseForm";
import * as formFields from "../../utils/forms/formFields";
import * as doorCalls from "../../store/api/calls/doors";
import {
  defaultPolyStyle,
  districtSelectionGlowStyle,
  districtStatusPointStyle,
  groupedRelativePointStyle,
} from "../maps/BaseMapStyles";
import { pullSiteNoteCategories } from "../../store/api/calls";
import { withRouter } from "../../utils/withRouter";
import TurfCutterMapLegend from "../maps/controls/TurfCutterMapLegend";

const US_DEFAULT_MAP_VIEW = {
  longitude: defaultMapState.center.lng,
  latitude: defaultMapState.center.lat,
  zoom: defaultMapState.zoom,
};

class TurfCutter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...defaultMapState,
      districtFeatures: [],
      turfFeatures: [],
      lassoedFeatures: [],
      loadedFeatures: [],
      features: [],

      //district vars
      selectedDistricts: [],
      districtType: "precinct_name",
      districtSidebarTab: "available",
      districtFilterText: null,
      listHoveredDistrictId: null,

      //turf vars
      turfs: [],
      editingTurf: null,
      turfEditModalOpen: false,
      releaseDoorsModalOpen: false,

      //status vars
      pageError: false,
      isLoading: false,
      errMsg: "Whoops! There's been a server error.",
      sideBarClosed: false,
      mapMode: "district", //can also be "turf"
      zoomLevel: 0,

      hoverInfoBoxIsActive: false,
      hoverInfoBoxInfo: [],

      doorcanvasspass: null,

      turfFilters: {
        id: "turfs",
        keyword: "",
        keywordPersist: "",
        noteTags: [],
        sortBy: "name",
        sortDsc: false,
        searchFields: ["name", "noteString", "code_name"],
        sortFields: [
          {
            display: "Name",
            value: "name",
          },
          {
            display: "Doors",
            value: "household_count",
          },
          {
            display: "Targets",
            value: "target_count",
          },
        ],
      },

      districtFilters: {
        id: "districts",
        keyword: "",
        keywordPersist: "",
        noteTags: [],
        sortBy: "name",
        sortDsc: false,
        searchFields: ["name", "noteString"],
        sortFields: [
          {
            display: "Name",
            value: "name",
          },
          {
            display: "Doors",
            value: "household_count",
          },
          {
            display: "Turfs",
            value: "turf_count",
          },
          {
            display: "% Cut",
            value: "cut",
          },
          {
            display: "Walkable",
            value: "walkable_cut",
          },
          {
            display: "Unwalkable",
            value: "unwalkable_cut",
          },
          {
            display: "Attempted",
            value: "attempted",
          },
        ],
      },
      hiddenTargets: [],
      hiddenTurfs: [],
      selectedPointsPoly: null,
      cutTurfPolys: [],
      visibleDistrictIds: null,
    };

    this.olMap = React.createRef();

    this.polygonSelectLayer = null;
    this.turfsLayer = null;

    this.modify = null;

    // corresponds to width var set in maps.scss
    this.sideBarColWidth = 280;

    // d3 scheme paired
    this.routeColors = [
      "#a6cee3",
      "#1f78b4",
      "#b2df8a",
      "#33a02c",
      "#fb9a99",
      "#e31a1c",
      "#c6158a",
      "#ff7f00",
      "#cab2d6",
      "#40399a",
      "#ecb012",
    ];

    this.unwalkableRouteColor = "#b14c0a";

    // this is min/max value of the household count to build the d3 scales
    this.districtScaleExtent = [];
    this.LABEL_ZOOM_THRESHOLD = 13;
    this.filterTimeout = null;
  }

  componentDidMount() {
    this._bootFromUrl();
    doorCalls.getTurfCodes();
    pullSiteNoteCategories();
  }

  componentWillUnmount() {
    clearTimeout(this.lassoHandle);
  }

  componentDidUpdate(prevProps, prevState) {
    // the cut-context redirect swaps the pass in place without remounting
    if (
      prevProps.params.doorcanvass_pass_id !==
      this.props.params.doorcanvass_pass_id
    ) {
      this._bootFromUrl();
    }

    if (this.state.turfs !== prevState.turfs) {
      this.setState({ cutTurfPolys: this.buildCutTurfPolys() });
    }

    if (
      prevState.isLoading &&
      !this.state.isLoading &&
      this.state.mapMode === "district" &&
      this.state.districtFeatures.length > 0
    ) {
      this._syncSidebarVisiblePointsFromMap();
    }
  }

  buildCutTurfPolys = () => {
    return this.state.turfs
      .filter((turf) => turf?.id && Array.isArray(turf.targets))
      .map((turf) => {
        // Turf POST returns every remaining target id; only some are in the
        // currently loaded district cut. Skip holes so encodePoints doesn't crash.
        const turfFeatures = turf.targets
          .map((target) => this.state.turfFeatures.find((t) => t.id === target))
          .filter(Boolean);

        let encodedPoints = this.encodePoints(turfFeatures);

        let poly = null;

        if (encodedPoints.features.length > 2) {
          poly = convex(encodedPoints);
        }

        if (poly) {
          poly = transformScale(poly, 1.1);
        }

        return (
          !!poly && {
            ...poly,
            properties: {
              polyColor: this.getTurfColor(turf, turf.id),
              data: turf,
            },
            id: turf.id,
          }
        );
      });
  };

  handleTurfsOnFilter = () => {
    let visibleTurfs = filterAndSortItems(
      this.state.turfs,
      this.state.turfFilters
    );

    let visibleTargets = visibleTurfs.map((t) => t.targets).flat();

    let hiddenTurfs = this.state.turfs.filter(
      (turf) => !visibleTurfs.find((vTurf) => vTurf.id === turf.id)
    );

    let hiddenTargets = hiddenTurfs.map((t) => t.targets).flat();
    // need for onmouseenter disabling to work
    this.setState({
      hiddenTargets,
      hiddenTurfs,
    });
  };

  handleDistrictsOnFilter = () => {
    let visibleDistricts = filterAndSortItems(
      this.state.districtFeatures,
      this.state.districtFilters
    );
    let visibleIds = visibleDistricts.map((d) => d.id);
    let hiddenIds = this.state.districtFeatures
      .filter((d) => !visibleIds.includes(d.id))
      .map((d) => d.id);
  };

  handleDistrictFilterModalClose = (filters) => {
    this.setState(
      {
        filterModalOpen: false,
        districtFilters: { ...this.state.districtFilters, ...filters },
      },
      () => this.handleDistrictsOnFilter()
    );
  };

  handleTurfFilterModalClose = (filters) => {
    this.setState(
      {
        filterModalOpen: false,
        turfFilters: { ...this.state.turfFilters, ...filters },
      },
      () => this.handleTurfsOnFilter()
    );
  };

  _getDistrictTypeDisplay = () => {
    const field = (this.state.cutableFields || []).find(
      (d) => d.value === this.state.districtType
    );
    return field?.display || this.state.districtType;
  };

  resetMapToDefaultView = () => {
    const map =
      this.mapRef?.current?.getMap?.() || this.mapRef?.current;
    if (map?.jumpTo) {
      map.jumpTo({
        center: [US_DEFAULT_MAP_VIEW.longitude, US_DEFAULT_MAP_VIEW.latitude],
        zoom: US_DEFAULT_MAP_VIEW.zoom,
      });
    } else if (map?.panTo) {
      map.panTo(
        [US_DEFAULT_MAP_VIEW.longitude, US_DEFAULT_MAP_VIEW.latitude],
        { animate: false }
      );
      map.zoomTo?.(US_DEFAULT_MAP_VIEW.zoom, { animate: false });
    }
  };

  _fitMapToPointFeatures = (
    points,
    source = "turf-points",
    respectCurrentZoomIfLower = false
  ) => {
    if (!points?.length || !this.mapRef?.current) {
      return;
    }
    setBoundsToSources(
      [{ data: this.encodePoints(points, source) }],
      this.mapRef,
      { respectCurrentZoomIfLower }
    );
  };

  _pointsForListItemZoom = (data, isDistrict) => {
    if (isDistrict) {
      return [data];
    }

    const seenClusters = new Set();
    const points = [];
    (data.targets || []).forEach((targetId) => {
      const feature = this.state.turfFeatures.find((t) => t.id === targetId);
      if (!feature) {
        return;
      }
      const clusterKey = feature.cluster_hash || String(feature.id);
      if (seenClusters.has(clusterKey)) {
        return;
      }
      seenClusters.add(clusterKey);
      points.push(feature);
    });
    return points;
  };

  zoomMapToListItem = (data, isDistrict) => {
    const source = isDistrict ? "district-points" : "turf-points";
    const points = this._pointsForListItemZoom(data, isDistrict);
    this._fitMapToPointFeatures(points, source, true);
  };

  _getVisibleDistrictsForSidebar = () => {
    const visiblePoints = this.state.viewState?.visiblePoints;
    return filterAndSortItems(
      this.state.districtFeatures,
      this.state.districtFilters
    ).filter((district) => {
      if (visiblePoints == null) {
        return true;
      }
      return visiblePoints.indexOf(district.id) > -1;
    });
  };

  _syncSidebarVisiblePointsFromMap = () => {
    const mapWrapper = this.mapRef?.current;
    const map = mapWrapper?.getMap?.() || mapWrapper;
    if (!map?.getBounds || !this.state.districtFeatures.length) {
      return;
    }

    const bounds = map.getBounds();
    const sources = [
      {
        id: "district-points",
        style: { type: "circle" },
        data: this.encodePoints(
          filterAndSortItems(
            this.state.districtFeatures,
            this.state.districtFilters
          ),
          "district-points"
        ),
      },
    ];

    const visiblePoints = getFeaturesWithinScreen(bounds, sources, this.mapRef);
    const prevPoints = this.state.viewState?.visiblePoints;
    if (
      prevPoints &&
      prevPoints.length === visiblePoints.length &&
      prevPoints.every((id, index) => id === visiblePoints[index])
    ) {
      return;
    }

    this.setState((prev) => ({
      viewState: {
        ...prev.viewState,
        visiblePoints,
      },
    }));
  };

  zoomMapToDistrictList = (districts) => {
    if (!districts?.length) {
      return;
    }
    this._fitMapToPointFeatures(districts, "district-points", false);
  };

  _setDistrictListHover = (districtId) => {
    if (districtId == null) {
      this.setState({
        hoveredFeatures: [],
        hoveredSource: null,
        listHoveredDistrictId: null,
      });
      return;
    }
    this.setState({
      hoveredFeatures: [districtId],
      hoveredSource: "district-points",
      listHoveredDistrictId: districtId,
    });
  };

  _renderDistrictTabLabel = (label, districts, zoomTitle) => {
    const disabled = !districts?.length;
    return (
      <span className="turfcutter-sidebar__tab-label">
        {label}
        <i
          className={`turfcutter-sidebar__tab-zoom fas fa-search-plus${
            disabled ? " is-disabled" : ""
          }`}
          title={
            disabled
              ? "No districts to zoom to"
              : zoomTitle || `Zoom map to ${label}`
          }
          aria-label={zoomTitle || `Zoom map to ${label}`}
          onClick={(e) => {
            e.stopPropagation();
            if (!disabled) {
              this.zoomMapToDistrictList(districts);
            }
          }}
        />
      </span>
    );
  };

  // Deep links: /turfcutter/:pass?type=<field> opens district mode at that level.
  // ?turf=<id> resolves the turf's districts via /turfs/:id/cut-context/, and
  // ?type=&districts=<name>&districts=<name> goes straight into turf mode.
  _parseDeepLinkParams = () => {
    const searchParams = this.props.searchParams;
    return {
      turfId: Number(searchParams?.get("turf")) || null,
      type: searchParams?.get("type") || null,
      districts: (searchParams?.getAll("districts") || []).filter(Boolean),
    };
  };

  _buildDeepLinkQuery = ({ turfId, type, districts }) => {
    const query = new URLSearchParams();
    if (type) query.set("type", type);
    (districts || []).forEach((name) => query.append("districts", name));
    if (turfId) query.set("turf", turfId);
    return query;
  };

  _bootFromUrl = () => {
    this.deepLink = this._parseDeepLinkParams();
    const { turfId, type, districts } = this.deepLink;

    if (!turfId || districts.length) {
      if (districts.length) this.setLoading(true);
      return this.getCutableFields(type)
        .then(this._applyDeepLinkSelection)
        .catch((err) => {
          console.error("[TURF CUTTER BOOT ERROR]", err);
          this.deepLink = null;
          this.setLoading(false);
        });
    }

    this.setLoading(true);
    return api
      .get(`/turfs/${turfId}/cut-context/`)
      .then((res) => {
        const ctx = res.data || {};
        const resolved = {
          turfId,
          type: ctx.type,
          districts: ctx.districts || [],
        };
        const query = this._buildDeepLinkQuery(resolved);

        if (
          ctx.doorcanvasspass &&
          +ctx.doorcanvasspass !== +this.props.params.doorcanvass_pass_id
        ) {
          this.props.navigate(
            `/turfcutter/${ctx.doorcanvasspass}?${query.toString()}`,
            { replace: true }
          );
          return;
        }

        this.deepLink = resolved;
        this.props.setSearchParams(query, { replace: true });
        return this.getCutableFields(resolved.type).then(
          this._applyDeepLinkSelection
        );
      })
      .catch((err) => {
        const msg =
          get(err, "response.data.error") ||
          "Couldn't find the districts for this turf.";
        this.deepLink = null;
        return this.getCutableFields(type).then(() => this.setError(msg));
      });
  };

  _applyDeepLinkSelection = () => {
    const deepLink = this.deepLink;
    if (!deepLink || !deepLink.districts.length) {
      this.deepLink = null;
      return;
    }

    // districtview already surfaced its own error
    if (!this.state.districtFeatures.length) {
      this.deepLink = null;
      this.setLoading(false);
      return;
    }

    const wanted = new Set(deepLink.districts.map(String));
    const matched = this.state.districtFeatures
      .filter((d) => wanted.has(String(d.name)))
      .map(this._withDistrictMapSource);

    if (!matched.length) {
      this.deepLink = null;
      this.setError(
        `None of this turf's districts are available at ${this._getDistrictTypeDisplay()} level.`
      );
      return;
    }

    const matchedNames = new Set(matched.map((d) => String(d.name)));
    const unmatched = deepLink.districts.filter(
      (name) => !matchedNames.has(String(name))
    );
    if (unmatched.length) {
      this.props.setInfoFeedMessage({
        id: "deep-link-unmatched-districts",
        msg: `Not loaded (too few doors to cut): ${unmatched.join(", ")}`,
        timeOutLength: 15 * 1000,
      });
    }

    return new Promise((resolve) =>
      this.setState({ selectedDistricts: matched }, resolve)
    )
      .then(() => this._startCutTurf())
      .then((loaded) => loaded && this._focusDeepLinkedTurf(deepLink.turfId))
      .finally(() => {
        this.deepLink = null;
      });
  };

  _focusDeepLinkedTurf = (turfId) => {
    if (!turfId || this.state.mapMode !== "turf") {
      return;
    }
    const turf = this.state.turfs.find((t) => +t.id === +turfId);
    if (!turf) {
      this.props.setInfoFeedMessage({
        id: "deep-link-turf-missing",
        msg: "That turf wasn't found in these districts.",
        timeOutLength: 10 * 1000,
      });
      return;
    }
    this._fitMapToPointFeatures(
      this._pointsForListItemZoom(turf, false),
      "turf-points",
      false
    );
  };

  handleMountOrDistrictTypeChange = (options) => {
    const { params } = this.props;
    const doorcanvass_pass_id = params.doorcanvass_pass_id || 0;
    const keepLoading = !!(
      options &&
      typeof options === "object" &&
      options.keepLoading
    );

    this.setState({
      isLoading: true,
      doorcanvasspass: doorcanvass_pass_id,
      error: false,
      pageError: false,
    });
    return api
      .get(`/districtview/${doorcanvass_pass_id}/`, {
        type: this.state.districtType,
      })
      .then((res) => {
        const districts = res.data || [];

        if (!districts.length) {
          this.districtScaleExtent = [0, 1];
          this.setState(
            {
              districtFeatures: [],
              loadedFeatures: [],
              isLoading: false,
            },
            () => {
              this.resetMapToDefaultView();
              this.setError(
                `No districts found for "${this._getDistrictTypeDisplay()}". Try a different district type.`
              );
            }
          );
          return;
        }

        //set scale extent for display
        let household_counts = districts.map((d) => d.household_count);
        this.districtScaleExtent = [
          Math.min(...household_counts),
          Math.max(...household_counts),
        ];

        let districtFeatures = districts.map((d) => ({
          ...d,
          name: d.name + "", // force string
          onClick: (e) => {
            this.state.selectedDistricts.find((_d) => _d.id === d.id)
              ? this.handleSelectedDistrictRemoval(d)
              : this.handleAvailDistrictDoubleClick(d);
          },
        }));
        return new Promise((resolve) =>
          this.setState(
            {
              districtFeatures,
              loadedFeatures: cloneDeep(districtFeatures),
              isLoading: keepLoading,
            },
            resolve
          )
        );
      })
      .catch((err) => {
        this.setState({ isLoading: false, pageError: true });
      });
  };

  getCutableFields = (preferredType) => {
    let matched_dcp = this.props.doorCanvassPasses.find(
      (d) => d.id === +this.props.params.doorcanvass_pass_id
    );

    const parseCutableFields = () => {
      let cutableFields = get(
        matched_dcp,
        "canvass.cut_config.cutable_fields",
        []
      );

      if (!Array.isArray(cutableFields) || !cutableFields.length) {
        cutableFields = [
          { type: "precinct_name", display: "Precinct" },
          { type: "county_name", display: "County" },
          { type: "city", display: "City" },
          { type: "zip5", display: "Zipcode" },
        ];
      }

      cutableFields = cutableFields.map((d) => ({
        ...d,
        value: d.type,
      }));

      if (
        preferredType &&
        !cutableFields.find((d) => d.value === preferredType)
      ) {
        cutableFields = [
          ...cutableFields,
          { type: preferredType, display: preferredType, value: preferredType },
        ];
      }

      if (cutableFields.length) {
        return new Promise((resolve) =>
          this.setState({ cutableFields }, resolve)
        ).then(() =>
          this._handleChangeDistrictType(
            preferredType || this.state.cutableFields[0].value,
            { keepLoading: !!this.deepLink?.districts?.length }
          )
        );
      } else {
        this.setError("No cutable fields found");
      }
    };

    if (matched_dcp) {
      //match found
      return Promise.resolve(parseCutableFields());
    } else {
      return doorCalls.pullCampaignDoorCanvassPasses().then((data) => {
        matched_dcp = this.props.doorCanvassPasses.find(
          (d) => d.id === +this.props.params.doorcanvass_pass_id
        );
        return parseCutableFields();
      });
    }
  };

  _startCutTurf = () => {
    const { params } = this.props;
    const doorcanvass_pass_id = params.doorcanvass_pass_id || 0;


    this.setState({ isLoading: true });
    return api
      .post(`/districthouseholds/${doorcanvass_pass_id}/`, {
        districts: [...this.state.selectedDistricts.map((d) => d.name)],
        notes: 1,
        type: this.state.districtType,
      })
      .then((res) => {
        let features = res.data.households.map((d) => ({
          ...d,
          lon: +d.longitude,
          lat: +d.latitude,
        }));

        features = features.sort((a, b) => a.cluster_count < b.cluster_count);

        // we need to just kill lassoed so we can keep selected features for the districts
        // list while cutting
        let turfs = res.data.turfs.sort((a, b) => a.id < b.id);

        let source = new VectorSource({
          features: [],
        });

        turfs
          .map((turf) => this.setTurfCodeDataOnTurfObj(turf))
          .forEach((turf, idx) => {
            let color = this.getTurfColor(turf, turf.id);
            let opacity = turf.is_walkable === false ? 0.3 : 1;
            let strokeWidth = 3;
            let feature = this.buildConvexHullPoly({
              id: turf.id,
              name: turf.name,
              idsInPoly: turf.targets,
            });

            feature.setId(turf.id);

            feature.setStyle(coloredPolygonStyle(color, strokeWidth, opacity));
            source.addFeature(feature);
          });

        this.props.removeInfoFeedMessage("count_selected_districts");

        return new Promise((resolve) =>
          this.setState(
            {
              mapMode: "turf",
              turfFeatures: features,
              lassoedFeatures: [],
              isLoading: false,
              turfs,
            },
            () => {
              // Defer one frame so BaseMap has committed turf-points before we jump.
              requestAnimationFrame(() => {
                this._fitMapToPointFeatures(features);
                resolve(true);
              });
            }
          )
        );
      })
      .catch((err) => {
        console.error("[POST ERROR]", err);
        this.setState({ isLoading: false });
        return false;
      });
  };

  clearLassos = (styleConfig = {}) => {
    //use style config to edit style off default after removal
    this.setState({ lassoedFeatures: [], selectedPointsPoly: null }, () =>
      this.props.removeInfoFeedMessage("district-doors-count")
    );
  };

  _addLassoedDistrictsToSelected = () => {
    //first remove dupes
    let newDistrictList = [
      ...this.state.selectedDistricts,
      ...this.state.lassoedFeatures.map((d) => this._withDistrictMapSource(d)),
    ].filter((d, i, a) => a.findIndex((_d) => _d.id === d.id) === i);
    this.setState(
      {
        lassoedFeatures: [],
        selectedDistricts: newDistrictList,
        districtSidebarTab: "selected",
      },
      this.clearLassos({ fill: "#fdbf6f", save: true })
    );
  };

  _clearSelectedDistricts = (ids) => {
    ids = ids || this.state.selectedDistricts.map((d) => d.id);
    let selectedDistricts = [
      ...this.state.selectedDistricts.filter((d) => d.id),
    ];
    this.setState({ selectedDistricts: [] });
  };

  handleDblClick = () => {
    if (this.state.editingTurf) {
      this.cancelTurfUpdate();
      this.clearLassos({ clear: true });
      return;
    }

    this.clearLassos({ clear: true });
    if (this.polygonSelectLayer) {
      this.olMap.current.map.removeLayer(this.polygonSelectLayer);
      this.polygonLayer = null;
    }
  };

  handleMapZoom = (zoomLevel) => {
    const stateZoom = +this.state.zoomLevel.toString(); //clone to prevent update on state change
    this.setState({ zoomLevel });

    if (
      stateZoom < this.LABEL_ZOOM_THRESHOLD &&
      zoomLevel >= this.LABEL_ZOOM_THRESHOLD
    ) {
      this.olMap.current.featuresLayer.changed();
    }

    if (
      stateZoom >= this.LABEL_ZOOM_THRESHOLD &&
      zoomLevel < this.LABEL_ZOOM_THRESHOLD
    ) {
      this.olMap.current.featuresLayer.changed();
    }
  };

  onMarkerHover(point) {
    if (!point) {
      this.setState({ hoverInfoBoxIsActive: false, hoverInfoBoxInfo: [] });
    } else if (point.name && this.state.mapMode === "turf") {
      let turf = this.state.turfs.find((t) => t.id === point.get("id"));
      if (!turf) {
        console.warn("No Turf Found for color update");
        return;
      }

      let visibleTurf = !this.state.hiddenTurfs.find(
        (t) => point.get("id") === t.id
      );

      let turfColor = visibleTurf ? this.getTurfColor(turf, turf.id) : "#000";
    } else {
      let id = point.id;
      let feature = this.state.districtFeatures.find((d) => d.id === id);

      let visibleTarget = !this.state.hiddenTargets.includes(id);

      if (feature && this.state.mapMode === "turf" && visibleTarget) {
        this.setState({
          hoverInfoBoxIsActive: true,
          hoverInfoBoxInfo: [
            feature.street_address_1,
            feature.city_state_zip,
            `${feature.cluster_count} households`,
            `${this.state.districtFeatures.reduce(
              (r, d) =>
                d.cluster_hash === feature.cluster_hash
                  ? r + d.target_count
                  : r,
              0
            )} targets`,
          ],
        });
      } else if (!visibleTarget && this.state.mapMode === "turf") {
      }
    }
  }

  _handleChangeDistrictType = (districtType, options) => {
    this.clearLassos();
    return new Promise((resolve) =>
      this.setState(
        {
          districtType,
          selectedDistricts: [],
          lassoedFeatures: [],
        },
        resolve
      )
    ).then(() => this.handleMountOrDistrictTypeChange(options));
  };

  //turf functions
  createTurf = (inputs) => {
    this.setLoading();
    return api
      .post("/turfs/", {
        ...inputs,
        household_count: this.state.lassoedFeatures.length,
        target_count: this.state.lassoedFeatures.reduce(
          (r, d) => r + (d.target_count || 0),
          0
        ),
        doorcanvasspass: this.state.doorcanvasspass,
        targets: this.state.lassoedFeatures.map((d) => d.id),
      })
      .then((res) => {
        this.addTurfToMap(res.data);
        this.setSuccess();
        return res.data;
      })
      .catch((err) => {
        console.error(err);
        this.setError();
      });
  };

  removeTurfFromMap = (turf_id) => {
    this.setState({
      turfs: this.state.turfs.filter((turf) => turf.id !== turf_id),
    });
  };

  deleteTurf = (turf_id) => {
    return api
      .delete(`/turfs/${turf_id}/`)
      .then(() => {
        this.setSuccess();
        let deletionTurf = this.state.turfs.find((d) => d.id === turf_id);
        this.setState({
          turfs: this.state.turfs.filter((d) => d.id !== turf_id),
        });

        this.removeTurfFromMap(turf_id);
      })
      .catch((err) => {
        if (err.response && err.response.status === 409) {
          this.setError(
            "A turf you tried to delete is assigned today or in the future."
          );
        } else {
          this.setError();
        }
      });
  };

  getTurfColor = (turf, idx) => {
    if (!turf) return;

    if (turf.is_walkable === false) return this.unwalkableRouteColor;

    if (!turf.color) {
      let turfIndex =
        idx || this.state.turfs.findIndex((d) => d.id === turf.id);
      turfIndex = turfIndex >= 0 ? turfIndex : 0;
      return this.routeColors[turfIndex % this.routeColors.length];
    } else {
      return turf.color;
    }
  };

  setTurfCodeDataOnTurfObj = (turf) => {
    let turf_code_obj =
      this.props.turfCodes.find((d) => d.id === +turf.code) || {};
    turf.code_name = turf_code_obj.name;
    turf.is_walkable = turf_code_obj.walkable !== false;

    return turf;
  };

  // /turfs/ POST returns agg_data as a JSON string and every remaining target id
  // (including other districts). districthouseholds had already parsed agg_data and
  // filtered targets to the loaded cut — restore that shape before merging into state.
  normalizeTurfApiPayload = (data, fallback = {}) => {
    let agg_data = data.agg_data;
    if (typeof agg_data === "string") {
      try {
        agg_data = JSON.parse(agg_data);
      } catch (e) {
        agg_data = fallback.agg_data ?? null;
      }
    } else if (agg_data == null) {
      agg_data = fallback.agg_data ?? null;
    }

    const loadedIds = new Set(this.state.turfFeatures.map((f) => f.id));
    const targets = (data.targets || []).filter((id) => loadedIds.has(id));

    return { ...data, agg_data, targets };
  };

  //edit config here is only used when adding the turf back to the map after editing
  addTurfToMap = (turf, editConfig = {}) => {
    let idx = ![null, undefined].includes(editConfig.idx)
      ? editConfig.idx
      : this.state.turfs.length;
    turf = this.setTurfCodeDataOnTurfObj(turf);
    if (!turf.color) {
      turf.color = this.getTurfColor(turf, turf.id); //length will be the index when it's added, so we get the right color
    }
    let new_turfs = [...this.state.turfs];

    if (
      ![null, undefined].includes(editConfig.idx) &&
      editConfig.idx >= 0 &&
      editConfig.idx < new_turfs.length
    ) {
      new_turfs[editConfig.idx] = { ...new_turfs[editConfig.idx], ...turf };
    } else {
      const existingIdx = new_turfs.findIndex((d) => d.id === turf.id);
      if (existingIdx >= 0) {
        new_turfs[existingIdx] = { ...new_turfs[existingIdx], ...turf };
      } else {
        new_turfs.push(turf);
      }
    }
    this.setState({ turfs: new_turfs });

    // pull the feature and remove the polygonSelectLayer

    this.clearLassos(); // clear the lassoes
    this.polygonSelectLayer = null;
  };

  handleCreateTurfRequest = (households) => {
    this.setState({ turfEditModalOpen: true });
  };

  onCloseTurfEditModal = () => {
    this.setState({ turfEditModalOpen: false });
  };

  handleTurfItemHover = (turf, idx, entering = true) => {
    this.setState({
      hoveredFeatures: entering ? [turf.id] : null,
      hoveredSource: entering ? "convex-hulls" : null,
    });
  };

  makeTurfEditable = (turf) => {
    //pull the polygon out the turfs layer and into the district select layer
    this.removeTurfFromMap(turf.id);
    let targets = [...turf.targets];

    //we have the set of IDS, no map over loadedFeatures to pull the actual object
    //set this component's state.
    //we can't set lassoed features until after the editing turf, because if you do you will clash with
    //the feature that prevents selection of existing turfs (aka, prevents double assignment
    this.setState({ editingTurf: turf }, () => {
      this.setState(
        {
          lassoedFeatures: this.state.turfFeatures
            .filter((d) => targets.includes(d.id))
            .map((t) => {
              return { ...t, source: "turf-points" };
            }),
        },
        () => {
          this.setState({
            selectedPointsPoly:
              this.state.lassoedFeatures.length > 2 &&
              transformScale(
                convex(this.encodePoints(this.state.lassoedFeatures)),
                1.1
              ),
          });
        }
      );
    });
  };

  /*
   * post the actual changes. the post endpoint of /turfs/turf_id/, which is what edits request, accepts two
   * keys in the json dict: targets (an array of ids of targets to add) and remove_targets (an array of ids of targets to remove);
   */
  handleUpdateTurfRequest = () => {
    let { editingTurf: turf } = this.state;

    let lassoedIds = this.state.lassoedFeatures.map((d) => d.id);

    //build the array of ids that have been added to the turf
    let add_targets = lassoedIds.filter((d) => !turf.targets.includes(d));
    //build the array of ids that we need to remove
    let remove_targets = turf.targets.filter((d) => !lassoedIds.includes(d));

    this.setState({ isLoading: true });

    return api
      .post(`/turfs/${turf.id}/`, {
        ...turf,
        household_count: this.state.lassoedFeatures.length,
        target_count: this.state.lassoedFeatures.reduce(
          (r, d) => r + (d.target_count || 0),
          0
        ),
        targets: add_targets,
        remove_targets,
      })
      .then((res) => {
        let { data } = res;
        const normalized = this.normalizeTurfApiPayload(data, turf);
        this.setState({ editingTurf: null }, () => {
          this.addTurfToMap({ ...turf, ...normalized });
        });
        this.setSuccess();
      })
      .catch(() => {
        this.setError("Looks like we had a problem updating the turf.");
      });
  };

  cancelTurfUpdate = () => {
    let turfs = [...this.state.turfs];
    let editingTurf = { ...this.state.editingTurf };
    let turf_idx = turfs.findIndex((d) => d.id === editingTurf.id);
    this.setState({ editingTurf: null }, () => {
      this.addTurfToMap(editingTurf);
    });
  };

  handleReleaseUnknockedDoorsRequest = () => {
    this.setState({ releaseDoorsModalOpen: true });
  };

  onCloseReleaseDoorsModal = () => {
    this.setState({ releaseDoorsModalOpen: false });
  };

  releaseUnknockedDoors = () => {
    const turfsToProcess = this.state.editingTurf
      ? [
        this.state.turfs.find((t) => t.id === this.state.editingTurf.id) ||
        this.state.editingTurf,
      ]
      : filterAndSortItems(this.state.turfs, this.state.turfFilters);

    const updates = turfsToProcess
      .filter((turf) => turf?.id)
      .map((turf) => {
        const remove_targets = turf.targets.filter((targetId) => {
          const feature = this.state.turfFeatures.find((f) => f.id === targetId);
          return feature ? !feature.attempted : true;
        });
        return { turf, remove_targets };
      })
      .filter(({ remove_targets }) => remove_targets.length > 0);

    if (!updates.length) {
      this.setError("No unknocked doors to release in the selected turf(s).");
      this.onCloseReleaseDoorsModal();
      return Promise.resolve();
    }

    this.setState({ isLoading: true });

    return Promise.all(
      updates.map(({ turf, remove_targets }) => {
        const removeSet = new Set(remove_targets);
        const remainingFeatures = turf.targets
          .filter((id) => !removeSet.has(id))
          .map((id) => this.state.turfFeatures.find((f) => f.id === id))
          .filter(Boolean);
        return api.post(`/turfs/${turf.id}/`, {
          ...turf,
          targets: [],
          household_count: remainingFeatures.length,
          target_count: remainingFeatures.reduce(
            (r, d) => r + (d.target_count || 0),
            0
          ),
          remove_targets,
        });
      })
    )
      .then((responses) => {
        let turfs = [...this.state.turfs];
        responses.forEach((res, i) => {
          const { turf } = updates[i];
          const turf_idx = turfs.findIndex((d) => d.id === turf.id);
          const base = turf_idx >= 0 ? turfs[turf_idx] : turf;
          const normalized = this.normalizeTurfApiPayload(res.data, base);
          const merged = this.setTurfCodeDataOnTurfObj({
            ...base,
            ...normalized,
          });
          // Editing removes the turf from state first; put it back after release.
          if (turf_idx >= 0) {
            turfs[turf_idx] = merged;
          } else {
            turfs.push(merged);
          }
        });

        const releasedCount = updates.reduce(
          (n, u) => n + u.remove_targets.length,
          0
        );

        this.setState({ turfs, editingTurf: null }, () => {
          this.clearLassos();
          this.setSuccess(
            `Released ${releasedCount} unknocked door${releasedCount === 1 ? "" : "s"} from ${updates.length} turf${updates.length === 1 ? "" : "s"}.`
          );
          this.onCloseReleaseDoorsModal();
        });
      })
      .catch(() => {
        this.setError("Looks like we had a problem releasing unknocked doors.");
        this.setState({ isLoading: false });
      });
  };

  /*
   * Config keys
   * featureCallback: function to be called in forEachFeature loop, passed feature and index
   * idsInPoly: a list of ids of features in the poly layer
   * id: id of the created polygon
   * name: name of the created polygon
   */

  buildConvexHullPoly = (config) => {
    let targetCoords = [];
    let { idsInPoly, featureCallback } = config;

    // if (targetCoords.length > 2) {
    // targetPoints.push(targetPoints[0]); //last must be same as first to complete the ring;

    const pointRing = convexHull(targetCoords);
    let polygon = new Polygon([pointRing]); //scale up so it doesn't rest directly on the points
    //createEnclaves(polygon, source, idsInPoly); // no all points in the convex hull might have been selected
    polygon.scale(1.03);

    let feature = new Feature({
      geometry: polygon,
      id: config.id,
      name: config.name,
    });

    return feature;
    // }
  };

  filterFeaturesByName() {
    if (!this.state.districtFilterText || this.state.districtFilterText === "")
      return this.state.districtFeatures;

    const predicate = (o) => {
      for (const k in o) {
        const v = o["name"];
        if (typeof v === "Number") continue;
        const coercedValue = String(v);
        if (
          coercedValue
            .trim()
            .toLowerCase()
            .includes(this.state.districtFilterText)
        ) {
          return true;
        }
      }
      return false;
    };

    //check for the presence of this.state.filterText in various fields
    //go through unknown objects and check for presence in values
    return filter(this.state.districtFeatures, predicate);
  }

  handleDistrictFilterChange = (val) => {
    let TIMEOUT_LEN = 800;
    clearTimeout(this.filterTimeout);
    this.setState({ districtFilterText: val });
    if (val.length < 2) {
      if (
        this.state.districtFeatures.length !== this.state.loadedFeatures.length
      ) {
        this.filterTimeout = setTimeout(
          () =>
            this.setState({
              districtFeatures: cloneDeep(this.state.loadedFeatures),
            }),
          TIMEOUT_LEN
        );
      }
    } else {
      this.filterTimeout = setTimeout(
        () => this.setState({ districtFeatures: this.filterFeaturesByName() }),
        TIMEOUT_LEN
      );
    }
  };

  _withDistrictMapSource = (district) => ({
    ...district,
    source: district.source || "district-points",
  });

  handleAvailDistrictDoubleClick = (district) => {
    let selectedDistricts = [
      ...this.state.selectedDistricts,
      this._withDistrictMapSource(district),
    ];
    this.setState({ selectedDistricts });

    this.props.setInfoFeedMessage({
      id: "district-added-by-click",
      msg: `${this.state.districtType} ${district.name} added to selection`,
      timeOutLength: 10 * 1000,
    });
    this.props.setInfoFeedMessage({
      id: "count_selected_districts",
      msg: selectedDistricts.length + " Total Districts Selected",
      timeoutLength: selectedDistricts.length ? 9999999999 : 3000,
      onClick: selectedDistricts.length
        ? this.handleDeselectAllDistricts
        : null,
      onClickName: "Deselect All",
      cantClose: true,
    });
  };

  handleDeselectAllDoors = () => {
    this.setState({ lassoedFeatures: [] });
    this.props.removeInfoFeedMessage("count_selected_doors");
  };

  handleDeselectAllDistricts = () => {
    this.setState({ selectedDistricts: [] });
    this.props.removeInfoFeedMessage("count_selected_districts");
  };

  handleSelectedDistrictRemoval = (district) => {
    let selectedDistricts = [
      ...this.state.selectedDistricts.filter((d) => d.id !== district.id),
    ];
    this.setState({ selectedDistricts });

    this.props.setInfoFeedMessage({
      id: "count_selected_districts",
      msg: selectedDistricts.length + " Total Districts Selected",
      timeoutLength: selectedDistricts.length ? 9999999999 : 3000,
      onClick: selectedDistricts.length
        ? this.handleDeselectAllDistricts
        : null,
      onClickName: "Deselect All",
      cantClose: true,
    });
  };

  handleDistrictNoteCreateOrDestroy = (newDistricts) => {
    const oldDistricts = [...this.state.districtFeatures];
    const mergedDistricts = oldDistricts.map((district) => {
      const matchingDistrict = newDistricts.find((d) => d.id === district.id);
      return matchingDistrict ? matchingDistrict : district;
    });

    this.props.setDistrictNoteModalDistricts(newDistricts);
    this.setState({
      districtFeatures: mergedDistricts,
    });
  };

  handleTurfNoteCreateOrDestroy = (turf) => {
    let turfs = [...this.state.turfs];
    let turf_idx = turfs.findIndex((d) => d.id === turf.id);
    if (turf_idx > -1) {
      this.props.setTurfNoteModalTurf(turf);
      turfs[turf_idx] = turf;
    }

    this.setState({
      turfs,
    });
  };

  bulkAddDistrictNotes = () => {
    this.props.setDistrictNoteModalDistricts(this.state.selectedDistricts);
  };

  _renderSidebarHierarchy = () => {
    const mode = this.state.mapMode;
    const passLabel = this.state.doorcanvasspass
      ? `Pass ${this.state.doorcanvasspass}`
      : "Turf cutter";

    return (
      <div
        className="turfcutter-sidebar__hierarchy"
        aria-label="Workflow"
        data-component="TurfCutter"
      >
        <span className="turfcutter-sidebar__pass">{passLabel}</span>
        <span className="turfcutter-sidebar__chevron" aria-hidden="true">
          ›
        </span>
        <span
          className={`turfcutter-sidebar__step${mode === "district" ? " is-current" : " is-done"
            }`}
        >
          Districts
        </span>
        <span className="turfcutter-sidebar__chevron" aria-hidden="true">
          ›
        </span>
        <span
          className={`turfcutter-sidebar__step${mode === "turf" ? " is-current" : ""
            }`}
        >
          Turfs
        </span>
      </div>
    );
  };

  _renderDistrictSelectSideBar() {
    const visibleDistricts = this._getVisibleDistrictsForSidebar();
    const selectedDistricts = this.state.selectedDistricts;

    let tabClickHandler = (selection) => {
      this.setState({ districtSidebarTab: selection });
    };

    let tabs = [
      {
        display: this._renderDistrictTabLabel(
          "Available",
          visibleDistricts,
          "Zoom map to available districts"
        ),
        active: this.state.districtSidebarTab === "available",
        onClick: () => tabClickHandler("available"),
      },
      {
        display: this._renderDistrictTabLabel(
          "Selected" +
            (selectedDistricts.length > 0
              ? ` (${selectedDistricts.length})`
              : ""),
          selectedDistricts,
          "Zoom map to selected districts"
        ),
        active: this.state.districtSidebarTab === "selected",
        onClick: () => tabClickHandler("selected"),
      },
    ];

    let districtValue =
      this.state.districtFilters.keywordPersist !== ""
        ? { value: this.state.districtFilters.keyword }
        : { test: 1 };

    const debouncedDistrictSearch = debounce((query) => {
      const stateChanges = handleSearchChange(query);
      this.setState(
        {
          ...stateChanges[0],
          districtFilters: {
            ...this.state.districtFilters,
            keyword: stateChanges[1],
          },
        },
        () => this.handleDistrictsOnFilter()
      );
    }, 300);

    const districtTypeLabel = this._getDistrictTypeDisplay();
    const hasDistrictActions =
      !!this.state.lassoedFeatures.length ||
      !!this.state.selectedDistricts.length;

    return (
      <div className="turfcutter-sidebar" data-component="TurfCutter">
        <header className="turfcutter-sidebar__header" data-component="TurfCutter">
          {this._renderSidebarHierarchy()}
          <div className="turfcutter-sidebar__title-row">
            <h2 className="turfcutter-sidebar__title">Select districts</h2>
          </div>
          <p className="turfcutter-sidebar__subtitle">
            Map: {districtTypeLabel} · choose districts, then cut turf
          </p>
          <div className="turfcutter-sidebar__header-field">
            <Input
              type={"select"}
              title={"District type"}
              value={this.state.districtType}
              onChange={this._handleChangeDistrictType}
              options={this.state.cutableFields}
            />
          </div>
        </header>

        {hasDistrictActions && (
          <div
            className="turfcutter-sidebar__section turfcutter-sidebar__section--actions"
            data-component="TurfCutter"
          >
            {!!this.state.lassoedFeatures.length && (
              <BasicButton
                disabled={this.state.addRouteValue === ""}
                on_click={this._addLassoedDistrictsToSelected}
                aria_label="Add to Selected"
                label="Add to Selected"
                className="mapButton"
              />
            )}

            {!!this.state.selectedDistricts.length && (
              <>
                <BasicButton
                  disabled={
                    this.state.addRouteValue === "" || this.state.isLoading
                  }
                  on_click={() => this._clearSelectedDistricts()}
                  aria_label="Clear Selection"
                  label="Clear Selection"
                  className="mapButton danger light danger-text"
                />
                <BasicButton
                  disabled={
                    this.state.addRouteValue === "" || this.state.isLoading
                  }
                  on_click={() => this._startCutTurf()}
                  label="Cut Turf"
                  className="mapButton success light success-text"
                />
                <BasicButton
                  on_click={() => this.bulkAddDistrictNotes()}
                  label="Bulk add notes"
                  className="mapButton success light success-text"
                />
              </>
            )}
          </div>
        )}

        {!!this.state.selectedDistricts.length && (
          <div
            className="turfcutter-sidebar__section turfcutter-sidebar__section--metrics agg-metrics"
            data-component="TurfCutter"
          >
            <div className="agg-metric">
              <span className="metricKey">Households selected</span>
              <span className="metricValue" style={{ fontWeight: "bold" }}>
                {this.state.selectedDistricts.reduce(
                  (r, d) => +d.household_count + r,
                  0
                )}
              </span>
            </div>
            <div className="agg-metric">
              <span className="metricKey">Districts selected</span>
              <span className="metricValue" style={{ fontWeight: "bold" }}>
                {this.state.selectedDistricts.length}
              </span>
            </div>
          </div>
        )}

        <div className="side-menu-body turfcutter-sidebar__body" data-component="TurfCutter">
          <div className="turfcutter-sidebar__section turfcutter-sidebar__section--tabs">
            <Tabs tabs={tabs} center={true} style={{ marginBottom: 0 }} />
          </div>

          {this.state.districtSidebarTab === "available" && (
            <>
              <div className="turfcutter-sidebar__section turfcutter-sidebar__section--filters">
                <FilterDisplay
                  filters={this.state.districtFilters}
                  openFilterModal={() => {
                    this.setState({ filterModalOpen: true });
                  }}
                  handleFilterDeletion={(filterType, val, filters) => {
                    this.setState(
                      {
                        districtFilters: handleFilterDeletion(
                          filterType,
                          val,
                          filters
                        ),
                      },
                      this.handleDistrictsOnFilter
                    );
                  }}
                  handleSearchChange={(val) => {
                    debouncedDistrictSearch(val);
                  }}
                  handleSortUpdate={(val) => {
                    this.setState({
                      districtFilters: {
                        ...this.state.districtFilters,
                        sortBy: val,
                      },
                    });
                  }}
                  handleSortDirectionChange={() =>
                    this.setState({
                      districtFilters: {
                        ...this.state.districtFilters,
                        sortDsc: !this.state.districtFilters.sortDsc,
                      },
                    })
                  }
                  value={districtValue}
                />
              </div>
              {visibleDistricts.map((d) => (
                <DistrictTurfListItem
                  isDistrict
                  data={d}
                  focused={this.state.listHoveredDistrictId === d.id}
                  selected={
                    !!this.state.selectedDistricts.filter((_d) => _d.id === d.id)
                      .length
                  }
                  color={
                    this.state.selectedDistricts.filter((_d) => _d.id === d.id)
                      .length
                      ? "#fdbf6f"
                      : null
                  }
                  key={d.id}
                  onMouseEnter={() => this._setDistrictListHover(d.id)}
                  onMouseLeave={() => this._setDistrictListHover(null)}
                  onClick={() => {
                    const deconstructedDistrict = {
                      ...d,
                      source: "district-points",
                    };
                    const doorcanvass_pass_id =
                      this.props.params.doorcanvass_pass_id || 0;
                    api
                      .post(`/districthouseholds/${doorcanvass_pass_id}/`, {
                        districts: [d.name],
                        notes: 1,
                        type: this.state.districtType,
                      })
                      .then((res) => {
                        console.log("[DistrictTurfListItem select]", {
                          object: d,
                          turfs: res.data.turfs,
                          households: res.data.households,
                        });
                      })
                      .catch((err) => {
                        console.log("[DistrictTurfListItem select]", {
                          object: d,
                          turfs: null,
                          households: null,
                          error: err,
                        });
                      });
                    this.state.selectedDistricts.filter((_d) => _d.id === d.id)
                      .length
                      ? this.handleSelectedDistrictRemoval(
                        deconstructedDistrict
                      )
                      : this.handleAvailDistrictDoubleClick(
                        deconstructedDistrict
                      );
                  }}
                  onZoomToMap={() => this.zoomMapToListItem(d, true)}
                />
              ))}
            </>
          )}

          {this.state.districtSidebarTab === "selected" && (
            <>
              <p className="turfcutter-sidebar__section-label">Your selection</p>
              {/*case of nothing selected*/}
              {!this.state.selectedDistricts.length && (
                <div
                  className="side-menu-list-obj district"
                  data-component="TurfCutter"
                >
                  <div
                    className="list-obj-inner-wrapper"
                    style={{ borderLeftColor: "#8a8a8a" }}
                  >
                    <div className="obj-title" style={{ color: "#8a8a8a" }}>
                      Nothing Selected
                    </div>
                  </div>
                </div>
              )}
              {/*case of something selected*/}
              {this.state.selectedDistricts.map((d) => (
                <DistrictTurfListItem
                  isDistrict
                  data={d}
                  focused={this.state.listHoveredDistrictId === d.id}
                  selected
                  key={d.id}
                  color={"#fdbf6f"}
                  hoverColor={"#c60115"}
                  onMouseEnter={() => this._setDistrictListHover(d.id)}
                  onMouseLeave={() => this._setDistrictListHover(null)}
                  onClick={() => null}
                  onRemove={() => this.handleSelectedDistrictRemoval(d)}
                  onZoomToMap={() => this.zoomMapToListItem(d, true)}
                />
              ))}
            </>
          )}
        </div>
      </div>
    );
  }

  _renderTurfCreateSideBar() {
    // District-wide rollup for the selected cut (not the sum of turf cards below).
    let total_doors = this.state.selectedDistricts.reduce(
      (r, d) => +d.household_count + r,
      0
    );
    // `attempted` on a district is a door count from aggregates__districtlevelstats.
    // Sum selected districts — do not count truthy rows across all loaded districts.
    let doors_attempted = this.state.selectedDistricts.reduce(
      (r, d) => r + (+d.attempted || 0),
      0
    );
    let walkable_cut = 0;
    let unwalkable_cut = 0;

    this.state.turfs.forEach((turf) => {
      if (turf.is_walkable) {
        walkable_cut += turf.targets.length;
      } else {
        unwalkable_cut += turf.targets.length;
      }
    });

    let cut_ratio = (walkable_cut + unwalkable_cut) / total_doors;
    let attempt_ratio = doors_attempted / total_doors;

    let turfValue =
      this.state.turfFilters.keywordPersist !== ""
        ? { value: this.state.turfFilters.keyword }
        : { test: 1 };

    const debouncedTurfSearch = debounce((query) => {
      const stateChanges = handleSearchChange(query);
      this.setState(
        {
          ...stateChanges[0],
          turfFilters: {
            ...this.state.turfFilters,
            keyword: stateChanges[1],
          },
        },
        this.handleTurfsOnFilter
      );
    }, 300);

    const districtSummary = this.state.selectedDistricts
      .map((d) => d.name)
      .join(", ");
    const hasTurfLassoActions = !!this.state.lassoedFeatures.length;

    return (
      <div className="turfcutter-sidebar" data-component="TurfCutter">
        <header className="turfcutter-sidebar__header" data-component="TurfCutter">
          {this._renderSidebarHierarchy()}
          <div className="turfcutter-sidebar__title-row">
            <button
              type="button"
              className="turfcutter-sidebar__back"
              aria-label="Back to district selection"
              onClick={this.returnToDistrictMode}
            >
              <i className="fa fa-level-up-alt" aria-hidden="true" />
            </button>
            <h2 className="turfcutter-sidebar__title">Build turfs</h2>
          </div>
          {districtSummary && (
            <p className="turfcutter-sidebar__subtitle" title={districtSummary}>
              Districts: {districtSummary}
            </p>
          )}

          <div className={"side-menu-info-box"} data-component="TurfCutter">
            <div className="obj-data">
              <span>
                <b>{total_doors}</b> doors · <b>{this.state.turfs.length}</b>{" "}
                turfs
              </span>
            </div>
            <div className="obj-data">
              <span>
                <b
                  className={cut_ratio > 0.98 ? "success-text" : "danger-text"}
                >
                  {Math.round(cut_ratio * 100)}% cut
                </b>
                — {walkable_cut} walkable,{" "}
                <span className={unwalkable_cut > 0 ? "danger-text" : ""}>
                  {unwalkable_cut} not walkable
                </span>
              </span>
            </div>
            <div className="obj-data">
              <span>
                <b className={"success-text"}>{doors_attempted} attempted</b> (
                {Math.round(attempt_ratio * 100)}%)
              </span>
            </div>
          </div>

          {!!this.state.turfs.length && (
            <>
              <p className="turfcutter-sidebar__hint">
                {this.state.editingTurf ? (
                  <>Editing {this.state.editingTurf.name}</>
                ) : (
                  <>Double click a turf to edit</>
                )}
              </p>
              {!this.state.editingTurf && (
                <BasicButton
                  on_click={this.handleReleaseUnknockedDoorsRequest}
                  aria_label="Release Unknocked Doors"
                  label="Release Unknocked Doors"
                  className="mapButton turfcutter-sidebar__release-unknocked"
                />
              )}
            </>
          )}
        </header>

        {hasTurfLassoActions && (
          <div
            className="turfcutter-sidebar__section turfcutter-sidebar__section--actions"
            data-component="TurfCutter"
          >
            {!this.state.editingTurf && (
              <BasicButton
                disabled={this.state.addRouteValue === ""}
                on_click={this.handleCreateTurfRequest}
                aria_label="Create Turf"
                label="Create Turf"
                className="mapButton"
              />
            )}

            {this.state.editingTurf && (
              <>
                <BasicButton
                  disabled={this.state.addRouteValue === ""}
                  on_click={() => this.setState({ turfEditModalOpen: true })}
                  aria_label="Edit Turf Options"
                  label="Edit Turf Options"
                  className="mapButton primary"
                />
                <BasicButton
                  disabled={this.state.addRouteValue === ""}
                  on_click={this.handleReleaseUnknockedDoorsRequest}
                  aria_label="Release Unknocked"
                  label="Release Unknocked"
                  className="mapButton"
                />
                <BasicButton
                  disabled={this.state.addRouteValue === ""}
                  on_click={this.cancelTurfUpdate}
                  aria_label="Cancel"
                  label="Cancel"
                  className="mapButton danger"
                />
                <BasicButton
                  disabled={this.state.addRouteValue === ""}
                  on_click={this.handleUpdateTurfRequest}
                  aria_label="Update Turf"
                  label="Update Turf"
                  className="mapButton success"
                />
              </>
            )}
          </div>
        )}

        {hasTurfLassoActions && (
          <div
            className="turfcutter-sidebar__section turfcutter-sidebar__section--metrics agg-metrics"
            data-component="TurfCutter"
          >
            <div className="agg-metric">
              <span className="metricKey">Households in lasso</span>
              <span className="metricValue" style={{ fontWeight: "bold" }}>
                {this.state.lassoedFeatures.length}
              </span>
            </div>
            <div className="agg-metric">
              <span className="metricKey">Targets in lasso</span>
              <span className="metricValue" style={{ fontWeight: "bold" }}>
                {this.state.lassoedFeatures.reduce(
                  (r, d) => r + (d.target_count || 0),
                  0
                )}
              </span>
            </div>
          </div>
        )}

        

        <div className="side-menu-body turfcutter-sidebar__body" data-component="TurfCutter">
          {!this.state.editingTurf && !this.state.lassoedFeatures.length && (
            <div
              className="side-menu-list-obj district"
              data-component="TurfCutter"
            >
              <div
                className="list-obj-inner-wrapper"
                style={{ borderLeftColor: "#8a8a8a" }}
              >
                <div
                  className="obj-title"
                  style={{
                    color: "#8a8a8a",
                    fontSize: "16px",
                    lineHeight: "1.1em",
                  }}
                >
                  Select some households to create a turf.
                </div>
              </div>
            </div>
          )}
          {!this.state.editingTurf && (
            <>
              <div className="turfcutter-sidebar__section turfcutter-sidebar__section--filters">
                <FilterDisplay
                  openFilterModal={() => {
                    this.setState({ filterModalOpen: true });
                  }}
                  filters={this.state.turfFilters}
                  handleSearchChange={(val) => {
                    debouncedTurfSearch(val);
                  }}
                  handleSortUpdate={(val) => {
                    this.setState({
                      turfFilters: {
                        ...this.state.turfFilters,
                        sortBy: val,
                      },
                    });
                  }}
                  handleSortDirectionChange={() =>
                    this.setState({
                      turfFilters: {
                        ...this.state.turfFilters,
                        sortDsc: !this.state.turfFilters.sortDsc,
                      },
                    })
                  }
                  handleFilterDeletion={(filterType, val, filters) => {
                    this.setState(
                      {
                        turfFilters: handleFilterDeletion(
                          filterType,
                          val,
                          filters
                        ),
                      },
                      this.handleTurfsOnFilter
                    );
                  }}
                  value={turfValue}
                />
              </div>

              <p className="turfcutter-sidebar__section-label">Walkable turfs</p>

              {filterAndSortItems(this.state.turfs, this.state.turfFilters)
                .filter((d) => d.is_walkable !== false)
                .map((d, i) => (
                  <DistrictTurfListItem
                    data={d}
                    focused={false}
                    key={d.id}
                    color={this.getTurfColor(d, d.id)}
                    onMouseEnter={() => this.handleTurfItemHover(d, i, true)}
                    onMouseLeave={() => this.handleTurfItemHover(d, i, false)}
                    onClick={() => null}
                    onRemove={() => this.deleteTurf(d.id)}
                    onDoubleClick={() => this.makeTurfEditable(d)}
                  />
                ))}

              <p className="turfcutter-sidebar__section-label">
                Not walkable turfs
              </p>

              {filterAndSortItems(this.state.turfs, this.state.turfFilters)
                .filter((d) => d.is_walkable === false)
                .map((d, i) => (
                  <DistrictTurfListItem
                    data={d}
                    focused={false}
                    key={d.id}
                    color={this.getTurfColor(d, d.id)}
                    onMouseEnter={() => this.handleTurfItemHover(d, i, true)}
                    onMouseLeave={() => this.handleTurfItemHover(d, i, false)}
                    onClick={() => null}
                    onRemove={() => this.deleteTurf(d.id)}
                    onDoubleClick={() => this.makeTurfEditable(d)}
                  />
                ))}
            </>
          )}
               
        </div>
      </div>
    );
  }

  returnToDistrictMode = () => {
    if (
      this.props.searchParams?.has("districts") ||
      this.props.searchParams?.has("turf")
    ) {
      this.props.setSearchParams(
        this._buildDeepLinkQuery({ type: this.state.districtType }),
        { replace: true }
      );
    }
    this.setState(
      {
        mapMode: "district",
        turfFeatures: [],
        cutTurfPolys: [],
        selectedPointsPoly: null,
      },
      this.handleMountOrDistrictTypeChange
    );
    this.handleDeselectAllDistricts();
    this.handleDeselectAllDoors();
  };

  isLoading = () => {
    return this.state.isLoading;
  };

  setError = (msg) => {
    msg = msg || "Server error.";
    this.setState(
      {
        errMsg: msg,
        error: true,
        isLoading: false,
      },
      () => {
        setTimeout(() => this.setState({ error: false }), 3000);
      }
    );
  };

  setLoading = (bool = true) => {
    this.setState({ isLoading: bool });
  };

  setSuccess = (msg) => {
    msg = msg || "Success";
    this.setState(
      {
        successMsg: msg,
        success: true,
        isLoading: false,
      },
      () => {
        setTimeout(() => this.setState({ success: false }), 3000);
      }
    );
  };

  encodePoints = (points, source) => {
    // Only households can be locked. District `attempted` is a count of knocked
    // doors, so treating it as a flag would lock a whole district on one knock.
    const lockable = source !== "district-points";

    return {
      type: "FeatureCollection",
      features: (points || [])
        .filter(Boolean)
        .map((point) => {
          const lng = Number(point.lon ?? point.longitude);
          const lat = Number(point.lat ?? point.latitude);
          if (!isValidLngLat(lng, lat)) {
            return null;
          }

          let turfColor;
          if (source === "turf-points") {
            const pointTurf = this.state.turfs.find(
              (t) => t?.targets?.indexOf(point.id) > -1
            );
            if (pointTurf) {
              turfColor =
                pointTurf.color || this.getTurfColor(pointTurf, pointTurf.id);
            }
          }

          return {
            type: "Feature",
            source: source,
            id: point.id,
            geometry: {
              type: "Point",
              coordinates: [lng, lat],
            },
            properties: {
              label: point.name,
              disabled: lockable && (!!point.suppressed || !!point.attempted),
              attemptedCount: +point.attempted || 0,
              data: point,
              count: point.household_count || point.cluster_count,
              cutRatio:
                point.household_count > 0
                  ? ((point.walkable_cut || 0) + (point.unwalkable_cut || 0)) /
                    point.household_count
                  : 0,
              source: source,
              groupColor: turfColor || "#9b4dca", // default to wox purple if not cut
            },
          };
        })
        .filter(Boolean),
    };
  };

  render() {
    return (
      <div id="turfcutter" data-component="TurfCutter">
        <FloatHeader link="/doorcanvass" />
        <div
          className="turfcutter-map-wrap"
          style={{ width: "100vw", height: "100vh" }}
          data-component="TurfCutter"
        >
          <BaseMap
            defaultViewState={US_DEFAULT_MAP_VIEW}
            // we only want the ref, and do not care about the bounds or visible features
            handleViewChange={(viewState, ref) => {
              this.setState({ viewState });
              if (ref) {
                this.mapRef = ref;
              }
            }}
            hoveredFeatures={this.state.hoveredFeatures}
            hoveredSource={this.state.hoveredSource}
            sources={[
              {
                id: "district-points",
                type: "geojson",
                data: this.encodePoints(
                  filterAndSortItems(
                    this.state.districtFeatures,
                    this.state.districtFilters
                  ),
                  "district-points"
                ),
                style: districtStatusPointStyle,
                underlayStyle: districtSelectionGlowStyle,
                internalCount: true,
                interpolateColor: true,
                isInteractive: true,
                hidden: this.state.mapMode === "turf",

                selectedFeatures: this.state.selectedDistricts,
                onHover: (features) => {
                  this.onMarkerHover(features[0].properties.data);
                  this.setState({
                    listHoveredDistrictId: features[0].id,
                  });
                },
                onEndHover: () => {
                  this.setState({ listHoveredDistrictId: null });
                },

                onMouseLeave: () => { },
                onClick: (feature) => {
                  const deconstructedFeature = {
                    ...feature.properties.data,
                    id: feature.id,
                    source: feature.source,
                  };
                  this.state.selectedDistricts.find(
                    (_d) => _d.id === feature.id
                  )
                    ? this.handleSelectedDistrictRemoval(deconstructedFeature)
                    : this.handleAvailDistrictDoubleClick(
                      deconstructedFeature
                    );
                },
                popupComponentGenerator: (feature) => {
                  const deconstructedFeature = feature.properties.data;
                  if (!deconstructedFeature) return <></>;

                  return (
                    <DistrictTurfListItem
                      data={deconstructedFeature}
                      focused={false}
                      key={feature.id}
                      color={this.getTurfColor(
                        deconstructedFeature,
                        feature.id
                      )}
                      isDistrict
                    />
                  );
                },
              },
              {
                id: "convex-hulls",
                type: "geojson",
                data: {
                  type: "FeatureCollection",
                  features: [
                    ...this.state.cutTurfPolys,
                    this.state.selectedPointsPoly,
                  ].filter((n) => n),
                },
                style: defaultPolyStyle,
                outline: true,
                isInteractive: true,
                onDblClick: (feature) => {
                  if (!feature.id) return;
                  this.makeTurfEditable(feature.properties.data);
                },
                popupComponentGenerator: (feature) => {
                  if (!feature.id) return;
                  return (
                    <DistrictTurfListItem
                      data={feature.properties.data}
                      focused={false}
                      key={feature.id}
                      color={this.getTurfColor(
                        feature.properties.data,
                        feature.id
                      )}
                      onRemove={() => this.deleteTurf(feature.id)}
                      onDoubleClick={() =>
                        this.makeTurfEditable(feature.properties.data)
                      }
                    />
                  );
                },
              },

              {
                id: "turf-points",
                type: "geojson",
                data: this.encodePoints(
                  this.state.turfFeatures,
                  "turf-points"
                ),
                style: groupedRelativePointStyle,
                isInteractive: true,
                selectedFeatures: this.state.lassoedFeatures,
                onHover: (features) => {
                  return null;
                },
                onClick: (feature) => {
                  const deconstructedFeature = {
                    ...feature.properties.data,
                    id: feature.id,
                    source: feature.source,
                  };

                  if (
                    this.state.turfs.find((turf) => {
                      return turf.targets.indexOf(feature.id) !== -1;
                    })
                  ) {
                    return;
                  }

                  this.state.lassoedFeatures.find((f) => f.id === feature.id)
                    ? this.setState({
                      lassoedFeatures: this.state.lassoedFeatures.filter(
                        (f) => f.id !== feature.id
                      ),
                    })
                    : this.setState({
                      lassoedFeatures: [
                        ...this.state.lassoedFeatures,
                        deconstructedFeature,
                      ],
                    });
                  this.props.setInfoFeedMessage({
                    id: "count_selected_doors",
                    msg:
                      this.state.lassoedFeatures.length +
                      " Total Doors Selected",
                    timeoutLength: this.state.lassoedFeatures.length
                      ? 9999999999
                      : 3000,
                    onClick: this.state.lassoedFeatures.length
                      ? this.handleDeselectAllDoors
                      : null,
                    onClickName: "Deselect All",
                    cantClose: true,
                  });

                  let encodedPoints = this.encodePoints(
                    this.state.lassoedFeatures
                  );

                  let poly = null;

                  if (encodedPoints.features.length > 2) {
                    poly = convex(encodedPoints);
                  }

                  if (poly) {
                    poly = transformScale(poly, 1.1);
                  }

                  this.setState({
                    selectedPointsPoly: poly,
                  });
                },
                popupComponentGenerator: (feature) => {
                  const deconstructedFeature = feature.properties.data;
                  return (
                    <div
                      id={"hover-info-box"}
                      className={"active"}
                      data-component="TurfCutter"
                    >
                      <div className={"hover-info-box-line"}>
                        <b>
                          {deconstructedFeature.street_address_1}{" "}
                          {deconstructedFeature.street_address_2}
                        </b>
                      </div>
                      <div className={"hover-info-box-line"}>
                        {deconstructedFeature.target_count} target
                        {deconstructedFeature.target_count > 1 && "s"}
                      </div>
                      <div className={"hover-info-box-line"}>
                        {deconstructedFeature.cluster_count} household
                        {deconstructedFeature.cluster_count > 1 && "s"}
                      </div>
                    </div>
                  );
                },
              },
            ]}
          />
        </div>

        <div
          className={`map-side-menu ${this.state.sideBarClosed && "closed"}`}
          data-component="TurfCutter"
        >
          <div
            className="side-menu-wrapper"
            id="side-menu-scroll-wrapper"
            data-component="TurfCutter"
          >
            {this.state.mapMode === "district" &&
              this._renderDistrictSelectSideBar()}
            {this.state.mapMode === "turf" && this._renderTurfCreateSideBar()}
          </div>
          <div
            className={`side-menu-select-wrapper ${this.state.sideBarClosed && "closed"
              }`}
            data-component="TurfCutter"
          >
            <div
              className="side-menu-option toggle"
              style={{ marginTop: "12vh" }}
              data-component="TurfCutter"
              onClick={() =>
                this.setState({ sideBarClosed: !this.state.sideBarClosed })
              }
            >
              <i
                className={`fas ${this.state.sideBarClosed ? "fa-arrow-left" : "fa-arrow-right"
                  }`}
              />
            </div>
            {this.isLoading() && (
              <div
                className={`side-menu-option loading`}
                data-component="TurfCutter"
              >
                <i className="fas fa-asterisk" />
              </div>
            )}
          </div>
        </div>

        <div
          className="turfcutter-bottom-left-stack"
          data-component="TurfCutter"
        >
          <TurfCutterMapLegend mode={this.state.mapMode} />
          <InfoTileFeed
            showInfoFeed={true}
            messageStyle={{
              lineHeight: "1.5m",
              color: "#1679c7", // primary text color
              fontWeight: "bold",
              alignItems: "center",
              justifyContent: "center",
              fontSize: ".8em",
              padding: ".5em",
              zIndex: "99",
            }}
          />
        </div>
        <FeedbackTile
          text={
            <div>
              <i
                className="fas fa-exclamation-triangle"
                style={{ marginRight: "15px" }}
              />
              {this.state.errMsg}
            </div>
          }
          visible={this.state.error}
          classNames="danger clear-sidebar-feedback-tile"
        />

        <FeedbackTile
          text={
            <div>
              <i
                className="fas fa-check-circle"
                style={{ marginRight: "15px" }}
              />
              {this.state.successMsg}
            </div>
          }
          visible={this.state.success}
          classNames="success clear-sidebar-feedback-tile"
        />

        {/* create turf modal */}
        <BaseModal
          open={this.state.turfEditModalOpen}
          onClose={this.onCloseTurfEditModal}
          center
        >
          <BaseForm
            inputs={[
              {
                ...formFields.genericName,
                validator: (val) => val && val.length > 1,
                errMsg: "You must give this at least a two character name.",
                value: this.state.editingTurf
                  ? this.state.editingTurf.name
                  : null,
              },
              {
                type: "text",
                title: "Notes",
                dataKey: "notes",
                placeholder: "",
                value: this.state.editingTurf
                  ? this.state.editingTurf.notes
                  : null,
              },
              {
                type: "select",
                title: "What kind of turf is this?",
                dataKey: "code",
                value: this.state.editingTurf ? this.state.editingTurf.code : 1,
                options: [
                  ...this.props.turfCodes.map((d) => ({
                    value: d.id,
                    display: d.name,
                  })),
                ],
              },
              {
                type: "text",
                title: "Intended Walk Date (M/D)",
                dataKey: "intended_walk_date",
                placeholder: "",
                value:
                  this.state.editingTurf &&
                    this.state.editingTurf.intended_walk_date
                    ? new Moment(
                      this.state.editingTurf.intended_walk_date,
                      "YYYY-MM-DD"
                    ).format("M/D")
                    : null,
                validator: (val) => {
                  if (!val || val === "") return true;
                  const isGoodDateRegexp =
                    /^(?:(0?[1-9]|1[012])[/](0?[1-9]|[12][0-9]|3[01]))$/;
                  return isGoodDateRegexp.test(val);
                },
                errorMsg: "Date must be in M/D format",
              },
            ]}
            onCancel={this.onCloseTurfEditModal}
            disableSubmit={this.state.isLoading}
            onSubmit={(inputs) => {
              // convert date input

              if (
                inputs.intended_walk_date &&
                inputs.intended_walk_date.length
              ) {
                inputs.intended_walk_date = new Moment(
                  inputs.intended_walk_date,
                  "M/D"
                ).format("YYYY-MM-DD");
              }
              if (!this.state.editingTurf) {
                this.createTurf(inputs).then((turf) => {
                  this.handleDeselectAllDoors();
                  this.onCloseTurfEditModal();
                  this.props.setTurfNoteModalTurf({ ...turf, turfnotes: [] });
                });
              } else {
                this.setState(
                  { editingTurf: { ...this.state.editingTurf, ...inputs } },
                  () =>
                    this.handleUpdateTurfRequest().then(
                      this.onCloseTurfEditModal
                    )
                );
              }
            }}
          />
        </BaseModal>

        {/* create release doors confirm modal */}
        <BaseModal
          open={this.state.releaseDoorsModalOpen}
          onClose={this.onCloseReleaseDoorsModal}
          center
        >
          <div className={"modalWrapper"} data-component="TurfCutter">
            <h5 style={{ marginBottom: "1em" }}>
              {this.state.editingTurf ? (
                <>
                  Are you sure you would like to release unknocked doors from{" "}
                  <span className={"primary-milligram-text"}>
                    {this.state.editingTurf.name}
                  </span>
                  ? This cannot be undone.
                </>
              ) : (
                <>
                  Are you sure you would like to release unknocked doors? This
                  will affect{" "}
                  <span className={"primary-milligram-text"}>
                    {filterAndSortItems(
                      this.state.turfs,
                      this.state.turfFilters
                    ).reduce(
                      (r, d) =>
                        get(d, "agg_data.households_attempted", 0) > 0
                          ? r + 1
                          : r,
                      0
                    )}
                  </span>{" "}
                  {/* this is the number of walked turfs */}
                  walked turfs and cannot be undone.
                </>
              )}
            </h5>
            <div className={"button-wrapper"}>
              <button
                className={"button"}
                disabled={this.state.isLoading}
                onClick={() => this.releaseUnknockedDoors()}
              >
                Yes
              </button>
              <button
                className={"button button-outline"}
                onClick={this.onCloseReleaseDoorsModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </BaseModal>

        <TurfNoteModal
          showCloseIcon
          center
          handleNoteCreateOrDestroy={this.handleTurfNoteCreateOrDestroy}
        />

        <DistrictNoteModal
          showCloseIcon
          center
          handleNoteCreateOrDestroy={this.handleDistrictNoteCreateOrDestroy}
        />
        {this.state.filterModalOpen &&
          (this.state.mapMode === "district" ? (
            <DistrictFilterModal
              showCloseIcon
              center
              handleOnClose={this.handleDistrictFilterModalClose}
              open={true}
              filters={this.state.districtFilters}
            />
          ) : (
            <TurfFilterModal
              showCloseIcon
              center
              handleOnClose={this.handleTurfFilterModalClose}
              open={true}
              filters={this.state.turfFilters}
            />
          ))}
        <FeedbackTile
          text={
            <div>
              <i
                className="fas fa-exclamation-triangle"
                style={{ marginRight: "15px" }}
              />
              {this.props.notesError || "There was a server error."}
            </div>
          }
          visible={this.props.notesError}
          classNames="danger"
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  focusedCampaign: state.session.focusedCampaign,
  turfCodes: state.turfCodes.data,
  doorCanvassPasses: state.doorCanvassPasses.data,
  notesError: state.siteNotes.error,
});

// TODO: is this necessary on this page?
const mapDispatchToProps = (dispatch) => ({
  setInfoFeedMessage: (msg) => dispatch(setInfoFeedMessage(msg)),
  removeInfoFeedMessage: (msg) => dispatch(removeInfoFeedMessage(msg)),
  setSelectedOffice: (id) =>
    dispatch(setDashboardParams({ selectedOffice: id })),
  setDistrictNoteModalDistricts: (district) =>
    dispatch(setSessionVar("districtNoteModalDistricts", district)),
  setTurfNoteModalTurf: (turf) =>
    dispatch(setSessionVar("turfNoteModalTurf", turf)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TurfCutter));
